<template>
  <div class="page" id="con_lf_top_div">
    <!--头部-->
    <el-header class="title"> <i class="iconfont icon-dingdanxiangqing-dingdanbianhao"></i>订单信息浏览 </el-header>
    <!--body内容-->
    <div class="page-content">
      <!--筛选条件-->
      <div style="background: #ededf0; color: #666e92">
        <el-form style="margin-left: 30px; font: bold" :inline="true" size="small" :model="formInline">
          <el-form-item label="月份:">
            <el-date-picker v-model="formInline.orderDate" format="yyyy-MM" value-format="yyyy-MM" type="month" placeholder="选择月"> </el-date-picker>
          </el-form-item>
          <el-form-item label="订单状态：">
            <el-select v-model="formInline.orderStatus" clearable placeholder="请选择" style="width: 100px">
              <el-option label="请选择" value />
              <el-option v-for="types in dataTypes" :key="types.code" :value="types.code" v-text="types.codeName" :label="types.codeName" />
            </el-select>
          </el-form-item>

          <el-form-item label="品牌筛选：">
            <el-select v-model="formInline.brand" clearable placeholder="请选择" style="width: 120px">
              <el-option label="请选择" value />
              <el-option v-for="types in dataBrands" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
            </el-select>
          </el-form-item>

          <el-form-item label="站点筛选：">
            <el-select v-model="formInline.site" style="width: 120px" clearable placeholder="请选择">
              <el-option label="请选择" value />
              <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
            </el-select>
          </el-form-item>
          <el-form-item label="数据类型：">
            <el-select v-model="formInline.type" style="width: 80px" clearable placeholder="请选择">
              <el-option label="请选择" value />
              <el-option v-for="types in typeDatas" :key="types.id" :value="types.id" v-text="types.name" :label="types.name" />
            </el-select>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input style="width: 190px" v-model="formInline.orderNo" clearable placeholder="订单号"></el-input>
          </el-form-item>
          <el-form-item label="SKU：">
            <el-input style="width: 180px" v-model="formInline.sku" clearable placeholder="SKU"></el-input>
          </el-form-item>
          <el-form-item label="FNSKU：">
            <el-input style="width: 115px" v-model="formInline.fnsku" clearable placeholder="FNSKU"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryParams" style="backgroundcolor: #2a3861; bordercolor: transparent">查询 </el-button>
            <el-button type="primary" @click="queryYxj" style="backgroundcolor: #2a3861; bordercolor: transparent">查看优先级 </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="templateDownload('订单导入模板')" style="backgroundcolor: #2a3861; bordercolor: transparent" v-if="this.user.companyId === 1">下载模板 </el-button>
            <el-button type="primary" @click="importOrderInfo" style="backgroundcolor: #2a3861; bordercolor: transparent" v-if="this.user.companyId === 1">订单导入 </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickAdd" style="backgroundcolor: #2a3861; bordercolor: transparent">新增订单 </el-button>
            <el-button type="primary" @click="downLoadOrderFile" style="backgroundcolor: #2a3861; bordercolor: transparent">导出订单 </el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <span class="user" @click="toggleFullScreen">
              <el-tooltip class="item" effect="dark" :content="isFullScreen ? '退出全屏' : '全屏'" placement="bottom">
                <i
                  :class="isFullScreen ? 'el-icon-aim' : 'el-icon-full-screen'"
                  style="
                    width: 50px;
                    height: 50px;
                    vertical-align: middle;
                    margin-right: 5px;
                    margin-bottom: 5px;
                    font-size: 20px;
                  "
                ></i>
              </el-tooltip>
            </span>
          </el-form-item>
        </el-form>
      </div>

      <!--表格-->
      <el-table
        height="calc(100vh - 1.8rem)"
        :header-cell-style="{
          'text-align': 'center',
          background: '#F5F6FA',
          color: '#646E92',
        }"
        border
        size="small"
        :span-method="objectSpanMethod"
        :cell-style="{ 'text-align': 'center' }"
        :row-style="{ height: '50px' }"
        :data="tableData"
        :row-class-name="tableRowClassName"
        :cell-class-name="tableRow"
        style="color: #666e92; margin-top: 20px; cursor: pointer; width: 100%"
        @cell-dblclick="editData"
      >
        <!-- @cell-dblclick="editData" -->
        <!--    @row-click="goToDetail" -->
        <el-table-column label="订单号" width="80" fixed>
          <div slot-scope="{ row }">
            <div :type="row.orderNo">
              <el-popover placement="top-start" width="260" trigger="hover" :content="row.orderNo">
                <span slot="reference"> {{ row.orderNo.length > 30 ? row.orderNo.substring(0, 20) + "..." : row.orderNo }}</span>
              </el-popover>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="SKU" prop="sku" width="100" fixed>
          <div slot-scope="{ row }">
            <div :type="row.sku" v-if="row.sku">
              <el-popover placement="top-start" width="260" trigger="hover" :content="row.sku">
                <span slot="reference"> {{ row.sku.length > 50 ? row.sku.substring(0, 50) + "..." : row.sku }}</span>
              </el-popover>
            </div>
          </div>
        </el-table-column>
        <el-table-column label="属性" prop="attribute" width="80" fixed>
          <div slot-scope="{ row }">
            <div :type="row.attribute" v-if="row.attribute">
              <el-popover placement="top-start" width="260" trigger="hover" :content="row.attribute">
                <span slot="reference"> {{ row.attribute.length > 20 ? row.attribute.substring(0, 20) + "..." : row.attribute }}</span>
              </el-popover>
            </div>
          </div>
        </el-table-column>
        <el-table-column prop="boxesNumber" label="箱数" width="50" fixed>
          <template slot-scope="scope">
            <div v-if="scope.row.detailId">
              <div v-if="row === scope.row.detailId && col == scope.column.id">
                <el-input
                  v-model="tmpRow.boxesNumber"
                  size="mini"
                  @blur="updateuserInfo"
                  type="number"
                  v-show="scope.row.type == 11002001 || (scope.row.type == 11002002 && scope.row.orderStatus == 11001001)"
                >
                </el-input>
              </div>
              <div v-else>
                {{ scope.row.boxesNumber }}
              </div>
            </div>
            <div v-else>
              <el-popover placement="top-start" width="180" trigger="hover" content="无订单明细不可双击修改">
                <i slot="reference" style="font-size: 14px; margin-left: 10px" class="el-icon-close"> </i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="boxSum" label="总箱数" width="60" fixed></el-table-column>
        <el-table-column prop="numberPackages" label="装箱数" width="60" fixed></el-table-column>
        <el-table-column prop="totalNumber" label="总数量" width="100" fixed>
          <template slot-scope="scope">
            <div v-if="scope.row.detailId">
              <div v-if="row === scope.row.detailId && col == scope.column.id">
                <el-input v-model="tmpRow.totalNumber" size="mini" @blur="updateuserInfo" type="number" />
              </div>
              <div v-else>
                {{ scope.row.totalNumber }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderDate" label="日期" :formatter="formatTime" show-overflow-tooltip width="85"></el-table-column>
        <el-table-column prop="fnsku" label="FNSKU" width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="channel" label="渠道" show-overflow-tooltip width="60">
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-input v-model="tmpRow.channel" size="mini" @blur="updateuserInfo" />
            </div>
            <div v-else>
              {{ scope.row.channel }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="countSum" label="订单总数" show-overflow-tooltip width="80">
          <!-- <template slot-scope="scope">
            {{ scope.row }}
          </template> -->
        </el-table-column>
        <el-table-column prop="priority" label="优先级" width="70">
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-input v-model="tmpRow.priority" size="mini" @blur="updateuserInfo" type="number" @keyup.native="imposeaa()" />
            </div>
            <div v-else>
              {{ scope.row.priority }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="deliveryDate" label="交货日期" :formatter="formatTime" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-date-picker
                v-model="tmpRow.deliveryDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 90%"
                type="date"
                @change="updateuserInfo"
              >
              </el-date-picker>
            </div>
            <div v-else>
              {{ scope.row.deliveryDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderRemark" label="运营备注" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-input type="textarea" v-model="tmpRow.orderRemark" size="mini" @blur="updateuserInfo" />
            </div>
            <div v-else>
              {{ scope.row.orderRemark }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="commitDate" label="提货时间" :formatter="formatTime" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-date-picker
                v-model="tmpRow.commitDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 90%"
                type="date"
                @change="updateuserInfo"
              >
              </el-date-picker>
            </div>
            <div v-else>
              {{ scope.row.commitDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sailDate" label="开船时间" :formatter="formatTime" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-date-picker
                v-model="tmpRow.sailDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 90%"
                type="date"
                @change="updateuserInfo"
              >
              </el-date-picker>
            </div>
            <div v-else>
              {{ scope.row.sailDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalDate" label="到港时间" :formatter="formatTime" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <div v-if="rowid === scope.row.id && col == scope.column.id">
              <el-date-picker
                v-model="tmpRow.arrivalDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 90%"
                type="date"
                @change="updateuserInfo"
              >
              </el-date-picker>
            </div>
            <div v-else>
              {{ scope.row.arrivalDate }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="订单操作区" width="150">
          <template slot-scope="{ row, $index }">
            <el-popover
              v-if="row.orderStatus == 11001001 && row.type == 11002002"
              placement="top-start"
              title="外采确认下单"
              width="100"
              trigger="hover"
              content="点击确认下单"
            >
              <i
                slot="reference"
                style="
                  color: rgb(30 194 38);
                  font-size: 20px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                class="el-icon-check"
                @click="outOrderConfirm(row)"
              >
              </i>
            </el-popover>
            <el-popover placement="top-start" title="删除" width="100" trigger="hover" content="点击可以删除订单信息">
              <i
                slot="reference"
                style="
                  color: red;
                  font-size: 20px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                class="el-icon-minus"
                @click="deleteOrder(row)"
              >
              </i>
            </el-popover>
            <el-popover placement="top-start" title="上传" width="100" trigger="hover" content="点击可以上传文件">
              <i
                slot="reference"
                style="
                  color: #2cc7c7;
                  font-size: 20px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                class="el-icon-upload2"
                @click="uploadOrderfile(row)"
              >
              </i>
            </el-popover>
            <el-popover placement="top-start" title="下载" width="100" trigger="hover" content="点击可以下载文件">
              <i
                slot="reference"
                style="
                  color: #2b69ee;
                  font-size: 20px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                class="el-icon-download"
                @click="clickFnskuDown(row)"
              >
              </i>
            </el-popover>
            <!-- <el-popover
              placement="top-start"
              title="下载"
              width="100"
              trigger="hover"
              content="点击可以下载压缩文件"
            >
              <i
                slot="reference"
                style="color: #2b69ee; font-size: 20px; margin-right: 10px"
                class="el-icon-download"
                @click="downloadAllfile(row)"
              >
              </i>
            </el-popover> -->
            <el-popover placement="top-start" title="确认发货" width="100" trigger="hover" content="点击确认发货">
              <i
                slot="reference"
                style="
                  color: rgb(30 194 38);
                  font-size: 20px;
                  margin-right: 10px;
                  cursor: pointer;
                "
                class="el-icon-finished"
                @click="confirmSend(row)"
              >
              </i>
            </el-popover>
            <el-popover placement="top-start" title="箱贴管理" width="100" trigger="hover">
              <i slot="reference" style="color: #2b69ee; font-size: 20px; margin-right: 10px" class="el-icon-document-copy" @click="orderList(row)"> </i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态" width="100">
          <template slot-scope="scope">
            {{
              scope.row.orderStatus == 11001001
                ? "未排单"
                : scope.row.orderStatus == 11001002
                ? "未完成"
                : scope.row.orderStatus == 11001003
                ? "未发货"
                : scope.row.orderStatus == 11001004
                ? "已发货"
                : scope.row.orderStatus == 11001005
                ? "已删除"
                : ""
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="orderRemark"
          label="订单备注"
          show-overflow-tooltip
          width="180"
        ></el-table-column> -->
        <el-table-column prop="factoryConfirmNumber" label="工厂确认每箱装的数量" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.detailId">
              <div v-if="row === scope.row.detailId && col == scope.column.id">
                <el-input v-model="tmpRow.factoryConfirmNumber" size="mini" @blur="updateuserInfo" type="number" />
              </div>
              <div v-else>
                {{ scope.row.factoryConfirmNumber }}
              </div>
            </div>
            <div v-else>
              <el-popover placement="top-start" width="180" trigger="hover" content="无订单明细不可双击修改">
                <i slot="reference" style="font-size: 14px; margin-left: 10px" class="el-icon-close"> </i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="factoryConfirmCtm" label="工厂确认总箱数" width="140">
          <template slot-scope="scope">
            <div v-if="scope.row.detailId">
              <div v-if="row === scope.row.detailId && col == scope.column.id">
                <el-input v-model="tmpRow.factoryConfirmCtm" size="mini" @blur="updateuserInfo" type="number" />
              </div>
              <div v-else>
                {{ scope.row.factoryConfirmCtm }}
              </div>
            </div>
            <div v-else>
              <el-popover placement="top-start" width="180" trigger="hover" content="无订单明细不可双击修改">
                <i slot="reference" style="font-size: 14px; margin-left: 10px" class="el-icon-close"> </i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="factoryConfirmKg" label="工厂确认重量KG" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.detailId">
              <div v-if="row === scope.row.detailId && col == scope.column.id">
                <el-input v-model="tmpRow.factoryConfirmKg" size="mini" @blur="updateuserInfo" type="number" />
              </div>
              <div v-else>
                {{ scope.row.factoryConfirmKg }}
              </div>
            </div>
            <div v-else>
              <el-popover placement="top-start" width="180" trigger="hover" content="无订单明细不可双击修改">
                <i slot="reference" style="font-size: 14px; margin-left: 10px" class="el-icon-close"> </i>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="detailRemark" label="工厂备注" show-overflow-tooltip width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.detailId">
              <div v-if="row === scope.row.detailId && col == scope.column.id">
                <el-input v-model="tmpRow.detailRemark" size="mini" type="textarea" @blur="updateuserInfo" />
              </div>
              <div v-else>
                {{ scope.row.detailRemark }}
              </div>
            </div>
            <div v-else>
              <el-popover placement="top-start" width="180" trigger="hover" content="无订单明细不可双击修改">
                <i slot="reference" style="font-size: 14px; margin-left: 10px" class="el-icon-close"> </i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" fixed="right" label="明细操作区" width="100">
          <template slot-scope="{ row, $index }">
            <el-popover placement="top-start" title="新增" width="80" trigger="hover" content="点击可以新增订单明细">
              <i slot="reference" style="color: rgb(30 194 38); font-size: 20px" class="el-icon-plus" @click="clickDetailAdd(row)"> </i>
            </el-popover>
            <el-popover placement="top-start" title="删除" width="80" trigger="hover" content="点击可以删除订单明细">
              <i
                v-if="row.detailId"
                slot="reference"
                style="color: red; font-size: 20px; margin-left: 10px"
                class="el-icon-minus"
                @click="deleteOrderDetail(row)"
              >
              </i>
            </el-popover>

            <!-- <i
              style="color: #2b69ee; font-size: 14px; margin-right: 10px"
              class="el-icon-download"
              @click="confirmOrderDialog = true"
            >
              确认
            </i> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--尾部-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 15, 20, 25, 30]"
        layout="total, sizes,prev, pager, next, jumper"
        :total="total"
        background
      />
    <!-- 新增订单 -->
    <el-dialog title="新增订单" width="600px" :visible.sync="addOrderDialog" class="import-dialog" :close-on-click-modal="false" :show-close="false" left>
      <el-form label-width="110px" :model="addorder" ref="addorder" :rules="rules1">
        <el-form-item label="订单前缀：" prop="prefix">
          <el-input v-model="addorder.prefix" disabled></el-input>
        </el-form-item>
        <el-form-item label="订单品牌：" prop="brand">
          <el-select v-model="addorder.brand" style="width: 100%" clearable placeholder="请选择">
            <el-option label="请选择" value />
            <el-option v-for="types in dataBrands" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
          <!-- <el-input v-model="addorder.brand"></el-input> -->
        </el-form-item>
        <el-form-item label="订单站点：" prop="site">
          <el-select v-model="addorder.site" style="width: 100%" clearable placeholder="请选择">
            <el-option label="请选择" value />
            <el-option v-for="types in dataSites" :key="types.codeValue" :value="types.codeValue" v-text="types.codeName" :label="types.codeName" />
          </el-select>
          <!-- <el-input v-model="addorder.site"></el-input> -->
        </el-form-item>
        <el-form-item label="渠道：" prop="channel">
          <el-input v-model="addorder.channel"></el-input>
        </el-form-item>

        <el-form-item label="优先级：" prop="priority">
          <el-input type="number" v-model="addorder.priority" @keyup.native="impose()"></el-input>
        </el-form-item>

        <el-form-item label="运营备注：" prop="orderRemark">
          <el-input type="textarea" v-model="addorder.orderRemark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAdd()">取 消</el-button>
        <el-button @click="addOrder('addorder')" style="background-color: #4c74e0; color: white">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 导入订单文件 -->
    <el-dialog title="上传文件" width="35%" :visible.sync="importOrderInfoShow" class="import-dialog" :close-on-click-modal="false" left>
        <el-form ref="addEditForm" label-width="125px">
          <el-form-item label="上传文件：">
            <el-upload
              class="upload-demo"
              ref="upload"
              drag
              :multiple="false"
              action="javascript:void(0)"
              :file-list="fileList"
              :auto-upload="false"
              :on-change="importOrderSubmitUpload"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-dialog>
    <!-- 新增订单明细 -->
    <el-dialog
      title="新增订单明细"
      width="600px"
      :visible.sync="addOrderDetailDialog"
      class="import-dialog"
      :close-on-click-modal="false"
      :show-close="false"
      left
    >
      <el-form label-width="110px" :model="addorderDetail" ref="addorderDetail" :rules="rules2">
        <el-form-item label="SKU：" prop="sku">
          <!-- <el-input v-model="addrole.type"></el-input> -->
          <el-select v-model="addorderDetail.sku" value-key="id" filterable style="width: 100%" @change="realChange">
            <el-option v-for="sku in Skudata" :key="sku.id" :value="sku.sku" :label="sku.sku" />
          </el-select>
        </el-form-item>

        <el-form-item label="属性：" prop="attribute">
          <el-input disabled v-model="addorderDetail.attribute"></el-input>
        </el-form-item>

        <el-form-item label="fnsku：" prop="fnsku">
          <el-input disabled v-model="addorderDetail.fnsku"></el-input>
        </el-form-item>
        <el-form-item label="装箱数：" prop="numberPackages">
          <el-input disabled v-model="addorderDetail.numberPackages"></el-input>
        </el-form-item>
        <el-form-item label="箱数：" prop="boxesNumber">
          <el-input v-model="addorderDetail.boxesNumber"></el-input>
        </el-form-item>

        <el-form-item label="备注：" prop="detailRemark">
          <el-input type="textarea" v-model="addorderDetail.detailRemark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDetailAdd()">取 消</el-button>
        <el-button @click="addOrderDetail('addorderDetail')" style="background-color: #4c74e0; color: white">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 确认订单明细 -->
    <el-dialog title="确认订单明细" width="600px" :visible.sync="confirmOrderDialog" class="center-dialog" :close-on-click-modal="false" left>
      <el-form label-width="150px" :model="confirmOrder" ref="confirmOrder" :rules="rules3">
        <el-form-item label="工厂确认每箱装的数量：" prop="factoryConfirmNumber">
          <el-input v-model="confirmOrder.factoryConfirmNumber"></el-input>
        </el-form-item>

        <el-form-item label="工厂确认总箱数：" prop="factoryConfirmCtm">
          <el-input type="number" v-model="confirmOrder.factoryConfirmCtm"></el-input>
        </el-form-item>

        <el-form-item label="工厂确认重量KG：" prop="factoryConfirmKg">
          <el-input type="number" v-model="confirmOrder.factoryConfirmKg"></el-input>
        </el-form-item>

        <el-form-item label="订单备注：" prop="detailRemark">
          <el-input type="textarea" v-model="confirmOrder.detailRemark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmOrderDialog = false">取 消</el-button>
        <el-button @click="confirmOrderDetail('confirmOrder')" style="background-color: #4c74e0; color: white">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 确认发货 -->
    <el-dialog title="确认发货" width="600px" :visible.sync="confirmSendShow" class="center-dialog" :close-on-click-modal="false" left>
      <el-form label-width="120px" :model="confirmOrderSend" ref="confirmOrderSend" :rules="rules4">
        <el-form-item label="运营备注：" prop="orderRemark">
          <el-input type="textarea" v-model="confirmOrderSend.orderRemark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelconfirmSend()">取 消</el-button>
        <el-button @click="confirmOrderSendSub('confirmOrderSend')" style="background-color: #4c74e0; color: white">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 上传FNSKU -->
    <el-dialog title="上传FNSKU" :visible.sync="dialogVisible" width="400px" class="center-dialog" :close-on-click-modal="false" center>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadBtnChange(0)" icon="iconfont icon-shujuxiazai" type="primary">PDF文件</el-button>
        <el-button @click="uploadBtnChange(1)" icon="iconfont icon-shujuxiazai" type="primary">相关文件</el-button>
      </span>
    </el-dialog>
    <!-- 上传文件 -->
    <el-dialog title="上传文件" :visible.sync="uploadDialog" width="600px" class="center-dialog" :close-on-click-modal="false" left>
      <el-form label-width="130px" :model="upload" ref="f1" :rules="rules1">
        <el-form-item label="上传文件：" prop="fileList">
          <el-upload
            class="upload-demo"
            drag
            ref="upload"
            :multiple="false"
            action="javascript:void(0)"
            :file-list="fileList"
            :auto-upload="false"
            :on-change="submitUpload"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <!-- <el-button
              slot="trigger"
              size="small"
              style="background-color: #2cc7c7; color: white"
              >选取文件</el-button
            > -->
          </el-upload>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialog = false">取 消</el-button>
        <el-button
          @click="doUpload"
          style="background-color: #2cc7c7; color: white"
          >完 成</el-button
        >
      </span> -->
    </el-dialog>
    <!-- 下载文件 -->
    <el-dialog title="下载文件" :visible.sync="downDialog" width="700px" class="center-dialog" :close-on-click-modal="false" center>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downFileFnsku(1)" class="el-icon-download" type="primary" style="margin-right: 20px">PDF文件下载</el-button>
        <el-button @click="downFileFnsku(0)" class="el-icon-download" type="primary" style="margin-right: 20px">外箱贴和相关文件</el-button>
        <el-button @click="downFileFnsku(2)" class="el-icon-download" style="margin-right: 20px" type="primary">相关文件下载</el-button>
      </span>
    </el-dialog>

    <el-dialog title="箱贴管理" :visible.sync="orderVisible" width="50%" :before-close="handleClose">
      <el-table :data="orderTableData" border style="width: 100%">
        <!-- <el-table-column
        prop="id"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="orderId"
        label="订单ID">
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="创建人">
      </el-table-column> -->
        <el-table-column prop="filePath" label="文件名称">
          <template slot-scope="scope">
            <div @click="download(scope.row.orgPath)">{{ scope.row.filePath }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" :formatter="formatTime"> </el-table-column>
        <!-- <el-table-column
        prop="updateBy"
        label="更新人"
        width="180">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="更新时间"  width="180">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column> -->
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="removeByOrderFileId(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderVisible = false">取 消</el-button>
        <el-button type="primary" @click="orderVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<!--行为-->
<script>
import find from "lodash/find";
import ElMain from "element-ui/packages/main/src/main";
import ElFooter from "element-ui/packages/footer/src/main";
import moment from "moment";
import SparkMD5 from "spark-md5";
// import { delete } from 'vue/types/umd';

var _ = { find };
export default {
  components: {
    ElFooter,
    ElMain,
  },
  /*属性定义*/
  data() {
    // var user = window.sessionStorage["user"];
    var user = JSON.parse(window.sessionStorage["user"]);
    return {
      tableHeight: this.tableHeight,
      tableHeight: window.innerHeight * 0.65,
      typeDatas: [
        {
          name: "内部",
          id: 11002001,
        },
        {
          name: "外部",
          id: 11002002,
        },
      ],
      importOrderInfoShow: false,
      formInline: {
        brand: "",
        orderStatus: "",
        site: "",
        orderDate: null,
        priority: 0,
        type: "",
        orderNo: "",
        fnsku: "",
        sku: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      pass_obj: {},
      passwd: "",
      user,
      dataBrands: [],
      dataSites: [],
      dataTypes: [],
      // 订单明细
      addOrderDetailDialog: false,
      addorderDetail: {
        orderId: "",
        skuInfoId: "",
        sku: "",
        attribute: "",
        boxesNumber: "",
        detailRemark: "",
        numberPackages: "",
        fnsku: "",
      },
      rules2: {
        sku: [{ required: true, message: "sku是必选的", trigger: "change" }],
        boxesNumber: [{ required: true, message: "箱数是必填的", trigger: "blur" }],
      },
      // 订单
      addOrderDialog: false,
      addorder: {
        brand: "",
        channel: "",
        orderRemark: "",
        prefix: "PO",
        priority: "",
        site: "",
        type: "",
      },
      rules1: {
        brand: [{ required: true, message: "品牌是必选的", trigger: "change" }],
        // channel: [{ required: true, message: '渠道是必填的', trigger: 'blur' }],
        prefix: [{ required: true, message: "订单前缀是必填的", trigger: "blur" }],
        site: [{ required: true, message: "站点是必选的", trigger: "change" }],
      },
      confirmOrderDialog: false,
      confirmOrder: {
        id: "",
        detailRemark: "",
        factoryConfirmCtm: "",
        factoryConfirmKg: "",
        factoryConfirmNumber: "",
      },
      rules3: {
        factoryConfirmCtm: [{ required: true, message: "工厂确认总箱数是必填的", trigger: "blur" }],
        factoryConfirmKg: [{ required: true, message: "工厂确认重量KG是必填的", trigger: "blur" }],
        factoryConfirmNumber: [{ required: true, message: "工厂确认每箱装的数量是必填的", trigger: "blur" }],
        // detailRemark: [{ required: true, message: '备注是必填的', trigger: 'blur' }],
      },
      Skudata: [],
      yxjPlus: false,
      uploadDialog: false,
      upload: {
        id: "",
        businessType: "",
        md5: "",
        chunks: 1,
        ext: "",
      },
      fileList: [],
      orderDetailId: null,
      businessType: 0,
      formFilename: "上传文件",
      spanArr: [],
      pos: 0,
      downDetailId: "",
      downorderId: "",
      downDetailfnskuPdfPath: "",
      downDialog: false,

      // 确认发货
      confirmSendShow: false,
      confirmOrderSend: { orderRemark: "" },
      rules4: {
        orderRemark: [{ required: true, message: "备注是必填的", trigger: "blur" }],
      },
      rowid: "",
      row: "",
      col: "",
      tmpRow: {},
      detailRemark: false,
      factoryConfirmCtm: false,
      factoryConfirmKg: false,
      factoryConfirmNumber: false,
      channel: false,
      orderStatus: "",
      orderRemark: false,
      priority: false,
      deliveryDate: false,
      commitDate: false,
      sailDate: false,
      arrivalDate: false,
      boxesNumber: false,
      downDetailfnskuPdfPathObj: [],
      fullscreen: false,
      browserKernel: "",
      canFullScreen: false,
      isFullScreen: false,
      orderVisible: false,
      orderTableData: [],
      myrow: {},
    };
  },

  /*created后调用*/
  mounted: function() {
    this.getAllSkus();
    this.getAllDicts();
    this.query();
    this.tableHeight = window.innerHeight - 250 + "px"; //255即表格之外的固定高度
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 255 + "px";
      })();
    };
    // 检查浏览器是否支持全屏
    this.canFullScreen = document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    if (document.webkitFullscreenEnabled) {
      this.browserKernel = "webkit";
    } else if (document.mozFullScreenEnabled) {
      this.browserKernel = "gecko";
    } else if (document.msFullscreenEnabled) {
      this.browserKernel = "trident";
    } else if (document.fullscreenEnabled) {
      this.browserKernel = "others";
    }
    if (this.canFullScreen) {
      this.addFullScreenListener();
    }
  },
  destroyed() {
    document.onkeydown = null;
    switch (this.browserKernel) {
      case "webkit":
        document.onwebkitfullscreenchange = null;
        break;
      case "gecko":
        document.onmozfullscreenchange = null;
        break;
      case "trident":
        document.onmsfullscreenchange = null;
        break;
      case "others":
        document.onfullscreenchange = null;
        break;
      default:
        break;
    }
  },

  /*选择数据后清空后值不在是array而是null watch监听*/
  watch: {
    "formInline.timerange"(newVal) {
      if (newVal == null) {
        this.formInline.timerange = [];
      }
    },
  },
  /*方法定义*/
  methods: {
    tableRowClassName({row, rowIndex}) {
        
        // console.log('seach:', row.sku.includes(this.formInline.sku));
        
        // if (this.formInline.sku) {
        //   if (row.sku.includes(this.formInline.sku)) {
        //     // console.log('进来了');
        //     // console.log('11row:', row);
        //     // console.log('rowIndex:', rowIndex);
        //     return 'success-row';
        //   }
        // }
        // if (row.orderStatus == 11001004) {
        //   return "purple-row";
        // }
        return '';
    },
    // 订单导入
    importOrderInfo() {
      // this.fileList = [];
      this.importOrderInfoShow = true;
    },
    // 订单导入模板下载
    templateDownload(fileName) {
      this.$msgbox
        .confirm("此操作将下载模板, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let path = "/api/sku-info/templateDownload?path=/order/template/" + fileName + ".xlsx";
          this.axios({
            url: path,
            method: 'get',
            responseType: 'blob',
          }).then(res => {
              this.downloadCallback(res, this.getFileName(res));
              /*加个下载成功的进度条*/
              setTimeout(() => {
                this.downImportDialog = false;
                this.$message({
                  message: "下载成功",
                  type: "success",
                  center: true,
                });
              }, 500);
            }
          ).catch(err => {
            console.log(err.message);
            this.$message.error("下载失败");
          });
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    orderList(row) {
      this.orderVisible = true;
      this.myrow = row;
      this.axios.get("/api/order/getOrderFile", { params: { orderId: row.id } }).then(
        (res) => {
          if (res.data.code == 200) {
            this.orderTableData = res.data.data;
            this.orderTableData.forEach((i) => {
              let filePath = i.filePath;
              i.filePath = filePath.substring(filePath.lastIndexOf("/") + 1, filePath.length);
              i.orgPath = filePath;
            });
          } else {
            this.orderTableData = [];
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
    // 下载文件
    download(row) {
      this.axios
        .get("/api/download?path=" + row, {
          responseType: "blob", // 表明返回服务器返回的数据类型
          method: "get",
          data: {},
        })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/octet-stream",
          });
          const downloadElement = document.createElement("a");
          // 创建下载的链接
          const href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          let filName = row.substring(row.lastIndexOf("/") + 1, row.length);
          // 下载后文件名
          downloadElement.download = filName;
          document.body.appendChild(downloadElement);
          // 点击下载
          downloadElement.click();
          // 下载完成移除元素
          document.body.removeChild(downloadElement);
          // 释放掉blob对象
          window.URL.revokeObjectURL(href);
        });
    },

    // 根据订单文件id删除文件信息
    removeByOrderFileId(row) {
      this.$msgbox
        .confirm("此操作将删除文件信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          //console.log('参数：' + row)
          this.axios.delete("/api/order/removeByOrderFileId?orderFileId=" + row).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.orderList(this.myrow);
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
    handleClose() {
      this.orderVisible = false;
    },
    handleorderDelete(id) {},
    //全屏设置
    toggleFullScreen() {
      if (this.canFullScreen) {
        if (this.isFullScreen) {
          // 关闭全屏
          this.exitFullScreen();
          this.isFullScreen = false;
        } else {
          // 打开全屏
          this.requestFullScreen(document.body);
          this.isFullScreen = true;
        }
      } else {
        this.$message.warning({
          content: "当前浏览器暂不支持全屏模式，请切换浏览器后重新尝试！",
          duration: 3,
        });
      }
    },
    requestFullScreen(element) {
      // 判断各种浏览器，找到正确的方法
      const requestMethod =
        element.requestFullScreen || // W3C
        element.webkitRequestFullScreen || // Chrome, safari
        element.mozRequestFullScreen || // FireFox
        element.msRequestFullscreen; // IE11
      if (requestMethod) {
        requestMethod.call(element);
      }
    },
    exitFullScreen() {
      var exitMethod =
        document.exitFullscreen || // W3C
        document.mozCancelFullScreen || // FireFox
        document.webkitExitFullscreen || // Chrome等
        document.msExitFullscreen; // IE11
      if (exitMethod) {
        exitMethod.call(document);
      }
    },
    addFullScreenListener() {
      const self = this;
      document.onkeydown = function(e) {
        if (e && e.keyCode === 122) {
          // 捕捉F11键盘动作
          e.preventDefault(); // 阻止F11默认动作
          self.toggleFullScreen();
        }
      };
      // 监听不同浏览器的全屏事件，并件执行相应的代码
      switch (self.browserKernel) {
        case "webkit":
          document.onwebkitfullscreenchange = function() {
            if (document.webkitIsFullScreen) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        case "gecko":
          document.onmozfullscreenchange = function() {
            if (document.mozFullScreen) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        case "trident":
          document.onmsfullscreenchange = function() {
            if (document.msFullscreenElement) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        case "others":
          document.onfullscreenchange = function() {
            if (document.fullscreen) {
              self.isFullScreen = true;
            } else {
              self.isFullScreen = false;
            }
          };
          break;
        default:
          break;
      }
    },

    screen() {
      // let element = document.documentElement;//设置后就是我们平时的整个页面全屏效果
      let element = document.getElementById("con_lf_top_div"); //设置后就是   id==con_lf_top_div 的容器全屏
      if ((this.fullscreen = false)) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    tableRow({row, column}) {
      if (this.formInline.sku) {
          if (row.sku.includes(this.formInline.sku)) {
            if (column.property === 'sku' || column.property === 'attribute' 
              || column.property === 'boxesNumber'
              || column.property === 'numberPackages'
              || column.property === 'totalNumber'
              || column.property === 'fnsku'
              || column.property === 'factoryConfirmNumber'
              || column.property === 'factoryConfirmCtm'
              || column.property === 'factoryConfirmKg'
              || column.property === 'detailRemark') {
              return 'success-row';
            }
          }
      }
      if (row.orderStatus == 11001004) {
        return "purple-row";
      }
    },
    imposeaa() {
      // this.dialogEditForm.name是input框绑定的值
      var str = this.tmpRow.priority;
      str = str.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
      // 正则替换，保留数字和小数点
      // str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null
      if (!str.includes(".")) {
        str = str + ".0";
      }
      this.tmpRow.priority = str;
    },
    impose() {
      // this.dialogEditForm.name是input框绑定的值
      var str = this.addorder.priority;
      str = str.replace(/^(\-)*(\d+)\.(\d).*$/, "$1$2.$3");
      // 正则替换，保留数字和小数点
      // str = str.match(/^\d*(\.?\d{0,1})/g)[0] || null
      if (!str.includes(".")) {
        str = str + ".0";
      }
      this.addorder.priority = str;
    },
    // 双击编辑修改单元格数据
    editData(row, column) {
      if (column.label.indexOf("工厂备注") == 0) {
        this.detailRemark = true;
      } else if (column.label.indexOf("工厂确认总箱数") == 0) {
        this.factoryConfirmCtm = true;
      } else if (column.label.indexOf("工厂确认重量KG") == 0) {
        this.factoryConfirmKg = true;
      } else if (column.label.indexOf("工厂确认每箱装的数量") == 0) {
        this.factoryConfirmNumber = true;
      } else if (column.label.indexOf("渠道") == 0) {
        this.channel = true;
      } else if (column.label.indexOf("运营备注") == 0) {
        this.orderRemark = true;
      } else if (column.label.indexOf("优先级") == 0) {
        this.priority = true;
      } else if (column.label.indexOf("交货日期") == 0) {
        this.deliveryDate = true;
      } else if (column.label.indexOf("提货时间") == 0) {
        this.commitDate = true;
      }  else if (column.label.indexOf("开船时间") == 0) {
        this.sailDate = true;
      }  else if (column.label.indexOf("到港时间") == 0) {
        this.arrivalDate = true;
      } else if (column.label.indexOf("箱数") == 0) {
        this.boxesNumber = true;
      } else if (column.label.indexOf("总数量") == 0) {
        this.totalNumber = true;
      }

      this.rowid = row.id;
      this.row = row.detailId;
      this.col = column.id;
      this.tmpRow = row;
      this.tmpRow.detailId = row.detailId;
      this.tmpRow.label = column.label;
    },

    //修改信息后调用修改信息的Api
    //双击失焦后的事件
    updateuserInfo() {
      let order = "";
      let path = "";
      if (this.detailRemark && this.tmpRow.label == "工厂备注") {
        order = { id: this.tmpRow.detailId, detailRemark: this.tmpRow.detailRemark };
        path = "/api/order-detail/confirm";
      } else if (this.factoryConfirmCtm && this.tmpRow.label == "工厂确认总箱数") {
        order = { id: this.tmpRow.detailId, factoryConfirmCtm: this.tmpRow.factoryConfirmCtm };
        path = "/api/order-detail/confirm";
      } else if (this.factoryConfirmKg && this.tmpRow.label == "工厂确认重量KG") {
        order = { id: this.tmpRow.detailId, factoryConfirmKg: this.tmpRow.factoryConfirmKg };
        path = "/api/order-detail/confirm";
      } else if (this.factoryConfirmNumber && this.tmpRow.label == "工厂确认每箱装的数量") {
        order = { id: this.tmpRow.detailId, factoryConfirmNumber: this.tmpRow.factoryConfirmNumber };
        path = "/api/order-detail/confirm";
      } else if (this.boxesNumber && this.tmpRow.label == "箱数") {
        order = { id: this.tmpRow.detailId, boxesNumber: this.tmpRow.boxesNumber };
        path = "/api/order-detail/modify";
      } else if (this.channel && this.tmpRow.label == "渠道") {
        order = { id: this.tmpRow.id, channel: this.tmpRow.channel };
        path = "/api/order";
      } else if (this.orderRemark && this.tmpRow.label == "运营备注") {
        order = { id: this.tmpRow.id, orderRemark: this.tmpRow.orderRemark };
        path = "/api/order";
      } else if (this.priority && this.tmpRow.label == "优先级") {
        order = { id: this.tmpRow.id, priority: this.tmpRow.priority };
        path = "/api/order";
      } else if (this.deliveryDate && this.tmpRow.label == "交货日期") {
        order = { id: this.tmpRow.id, deliveryDate: this.tmpRow.deliveryDate };
        path = "/api/order";
      } else if (this.commitDate && this.tmpRow.label == "提货时间") {
        order = { id: this.tmpRow.id, commitDate: this.tmpRow.commitDate };
        path = "/api/order";
      } else if (this.sailDate && this.tmpRow.label == "开船时间") {
        order = { id: this.tmpRow.id, sailDate: this.tmpRow.sailDate };
        path = "/api/order";
      } else if (this.arrivalDate && this.tmpRow.label == "到港时间") {
        order = { id: this.tmpRow.id, arrivalDate: this.tmpRow.arrivalDate };
        path = "/api/order";
      } else if (this.totalNumber && this.tmpRow.label == "总数量") {
        order = { id: this.tmpRow.detailId, totalNumber: this.tmpRow.totalNumber };
        path = "/api/order-detail/modify";
      }
      if (order != null && order != "") {
        this.axios.put(path, order).then(
          (resp) => {
            if (resp.data.code == 200) {
              this.$message("修改成功");
              this.query(); /*查询渲染界面*/
              //清空数据
              this.tmpRow = {};
              this.row = "";
              this.col = "";
              this.rowid = "";
            } else {
              this.$message.info("失败：" + resp.data.msg);
              this.query(); /*查询渲染界面*/
            }
          },
          (err) => {
            console.log("err", err);
          }
        );
      }
    },
    getAllSkus() {
      /*获取所有sku*/
      this.axios.get("/api/sku-info/list").then((r) => {
        let data = r.data.data;
        this.Skudata = data; //赋值给img标签的src属性
      });
    },
    getAllDicts() {
      /*获取所有字典*/
      this.axios.get("/api/dict/map").then((r) => {
        let data = r.data.data;
        for (var key in data) {
          if (key.indexOf("1100") == 0) {
            // 订单状态
            this.dataTypes = data[key];
          } else if (key.indexOf("1120") == 0) {
            // 品牌
            this.dataBrands = data[key];
          }
          if (key.indexOf("1130") == 0) {
            // 站点
            let siteData = data[key];
            siteData.map((item) => {
              item.codeName = item.codeValue + "（" + item.codeName + "）";
            });
            this.dataSites = siteData;
          }
        }
      });
    },
    realChange(val) {
      var obj = {};
      obj = this.Skudata.find(function(i) {
        return i.sku === val;
      });
      this.addorderDetail.attribute = obj.attribute;
      this.addorderDetail.fnsku = obj.fnsku;
      this.addorderDetail.numberPackages = obj.numberPackages;
      this.addorderDetail.skuInfoId = obj.id;
    },
    // 要合并的数组
    getSpanArr(data) {
      // console.log(data, 'data')
      this.spanArr = [];
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.pos = 0; // 指针
        } else {
          if (item["orderNo"] && item["orderNo"] === data[index - 1]["orderNo"]) {
            //当前项和前一项比较
            this.spanArr[this.pos] += 1; //相同值第一个出现的位置，统计需要合并多少行,指针往后移动一位
            this.spanArr.push(0); //新增一个被合并行 0表示要合并
          } else {
            this.spanArr.push(1); //否则不合并
            this.pos = index; //指向位移
          }
        }
      });
    },
    // 合并的行数
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0 ||
        columnIndex === 4 ||
        columnIndex === 7 ||
        columnIndex === 9 ||
        columnIndex === 10 ||
        columnIndex === 11 ||
        columnIndex === 12 ||
        columnIndex === 13 ||
        columnIndex === 14 ||
        columnIndex === 15 ||
        columnIndex === 16 || 
        columnIndex === 17 ||
        columnIndex === 18
      ) {
        // item.etype == '1' ? '订单' : '结算'
        const _row = this.spanArr[rowIndex];
        /*  
          第一行：_row = [2, 0, 2, 0][0] = 2
          第二行：_row = [2, 0, 2, 0][1] = 0
          第三行：_row = [2, 0, 2, 0][2] = 2
          第四行：_row = [2, 0, 2, 0][3] = 0
        */
        const _col = _row > 0 ? 1 : 0;
        /*  
          第一列：_col = 1
          第二列：_col = 0
          第三列：_col = 1
          第四列：_col = 0
        */
        // console.log('rowIndex', rowIndex) // 0, 1, 2, 3
        // console.log('spanArr', this.spanArr) // [2, 0, 2, 0]
        // console.log('_row', _row)
        // console.log('_col', _col)
        return {
          rowspan: _row, // rowspan: [2, 0, 2, 0]
          colspan: _col, // colspan: [1, 0, 1, 0]
          // 最终结果：
          // 合并两行合并1列, 不合并, 不合并
          // 合并两行合并1列, 不合并, 不合并
          // 第一行合并两行，第二行被合并，第三行合并两行，第四行被合并
          // 第一行合并1列，第二列被合并，第三行合并1列，第四行被合并
        };
      }
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return "";
      }
      // return moment(date).format("YYYY-MM-DD HH:mm:ss")
      return moment(date).format("YYYY-MM-DD");
    },

    /*每页显示数据量变更*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange() {
      this.query();
    },

    queryParams() {
      this.$data.currentPage = 1;
      this.query();
    },
    query() {
      //获取查询对象
      let o = {
        ...this.formInline,
      };
      if (this.formInline.orderDate != null) {
        o.orderDate = moment(this.formInline.orderDate).format("YYYY-MM");
      } else {
        delete o.orderDate;
      }
      if (this.formInline.priority != "1.0") {
        delete o.priority;
      }
      // console.log(o, ' o.orderDate')
      this.axios
        .get("/api/order/page", {
          params: { ...o, current: this.$data.currentPage, size: this.$data.pageSize },
        })
        .then(this.putdata, (err) => {
          console.log("err", err);
        });
    },
    /* 分页*/
    putdata(resp) {
      let orderArr = [];
      var newArr = resp.data.data && resp.data.data.records ? resp.data.data.records : [];
      this.$data.total = resp.data.data.total;
      for (var i = 0; i < newArr.length; i++) {
        var orderobject = {};
        orderobject.actualDeliveryDate = newArr[i].actualDeliveryDate;
        orderobject.channel = newArr[i].channel;
        orderobject.confirmDate = newArr[i].confirmDate;
        orderobject.deliveryDate = moment(newArr[i].deliveryDate).format("YYYY-MM-DD");
        orderobject.id = newArr[i].id;
        orderobject.orderDate = newArr[i].orderDate;
        orderobject.orderNo = newArr[i].orderNo;
        orderobject.orderRemark = newArr[i].orderRemark;
        orderobject.orderStatus = newArr[i].orderStatus;
        orderobject.type = newArr[i].type;
        orderobject.priority = newArr[i].priority;
        orderobject.commitDate = newArr[i].commitDate != null ? moment(newArr[i].commitDate).format("YYYY-MM-DD") : null;
        orderobject.sailDate = newArr[i].sailDate != null ? moment(newArr[i].sailDate).format("YYYY-MM-DD") : null;
        orderobject.arrivalDate = newArr[i].arrivalDate != null ? moment(newArr[i].arrivalDate).format("YYYY-MM-DD") : null;
        if (newArr[i].orderDetailVOS) {
          let countSum = 0;
          let fnskuPdfPathObj = [];
          let boxSum = 0;
          newArr[i].orderDetailVOS.forEach((item) => {
            //遍历totalNumber这个字段，并累加
            countSum += item.totalNumber;
            boxSum += item.boxesNumber;
            if (item.fnskuPdfPath) {
              fnskuPdfPathObj[i].push(item.fnskuPdfPath);
            }
          });
          for (var j = 0; j < newArr[i].orderDetailVOS.length; j++) {
            orderobject.attribute = newArr[i].orderDetailVOS[j].attribute;
            orderobject.boxesNumber = newArr[i].orderDetailVOS[j].boxesNumber;
            orderobject.detailRemark = newArr[i].orderDetailVOS[j].detailRemark;
            orderobject.factoryConfirmCtm = newArr[i].orderDetailVOS[j].factoryConfirmCtm;
            orderobject.factoryConfirmKg = newArr[i].orderDetailVOS[j].factoryConfirmKg;
            orderobject.factoryConfirmNumber = newArr[i].orderDetailVOS[j].factoryConfirmNumber;
            orderobject.fnsku = newArr[i].orderDetailVOS[j].fnsku;
            orderobject.fnskuPdfPath = newArr[i].orderDetailVOS[j].fnskuPdfPath;
            orderobject.detailId = newArr[i].orderDetailVOS[j].id;
            orderobject.numberPackages = newArr[i].orderDetailVOS[j].numberPackages;
            orderobject.sku = newArr[i].orderDetailVOS[j].sku;
            orderobject.totalNumber = newArr[i].orderDetailVOS[j].totalNumber;
            orderobject.countSum = countSum;
            orderobject.boxSum = boxSum;
            orderobject.fnskuPdfPathObj = fnskuPdfPathObj;
            // orderobject.operateRemark = newArr[i].orderDetailVOS[j].operateRemark;
            orderobject.detailRemark = newArr[i].orderDetailVOS[j].detailRemark;
            var newObj = JSON.parse(JSON.stringify(orderobject));
            orderArr.push(newObj);
          }
        } else {
          orderArr.push(orderobject);
        }
      }
      // console.log(orderArr, 'orderArr')
      this.$data.tableData = orderArr;
      this.getSpanArr(this.$data.tableData);
    },
    queryYxj() {
      if (this.yxjPlus) {
        this.yxjPlus = false;
        this.formInline.priority = "0";
      } else {
        this.yxjPlus = true;
        this.formInline.priority = "1.0";
      }
      this.query();
    },
    clickAdd() {
      this.addOrderDialog = true;
    },
    cancelAdd() {
      this.$refs.addorder.resetFields();
      this.addOrderDialog = false;
    },
    cancelDetailAdd() {
      this.$refs.addorderDetail.resetFields();
      this.addOrderDetailDialog = false;
    },
    clickDetailAdd(row) {
      this.addOrderDetailDialog = true;
      this.addorderDetail.orderId = row.id;
    },
    addOrder(addorder) {
      this.$refs[addorder].validate((valid) => {
        if (valid) {
          let order = { ...this.addorder };

          this.axios.post("/api/order/add", order).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.cancelAdd(); /*关闭弹窗*/
                this.$message("添加成功");
                this.query(); /*查询渲染界面*/
              } else {
                this.$message.error("添加失败");
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    addOrderDetail(addorderDetail) {
      this.$refs[addorderDetail].validate((valid) => {
        if (valid) {
          let orderDetail = { ...this.addorderDetail };

          this.axios.post("/api/order-detail/add", orderDetail).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.cancelDetailAdd(); /*关闭弹窗*/
                this.$message("添加成功");
                this.query(); /*查询渲染界面*/
              } else {
                this.$message.info(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    confirmSend(row) {
      this.confirmSendShow = true;
      this.confirmOrderSend.id = row.id;
    },
    // 确认发货
    cancelconfirmSend() {
      this.$refs.confirmOrderSend.resetFields();
      this.confirmSendShow = false;
    },
    confirmOrderSendSub(confirmOrderSend) {
      this.$refs[confirmOrderSend].validate((valid) => {
        if (valid) {
          let orderSend = { ...this.confirmOrderSend };
          this.axios.put("/api/order/confirm", orderSend).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.confirmSendShow = false; /*关闭弹窗*/
                this.$message("确认成功");
                this.query(); /*查询渲染界面*/
              } else {
                this.$message.info("失败：" + resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
          this.cancelconfirmSend();
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    confirmOrderDetail(confirmOrder) {
      this.$refs[confirmOrder].validate((valid) => {
        if (valid) {
          let order = { ...this.confirmOrder };

          this.axios.put("/api/order-detail/confirm", order).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.confirmOrderDialog = false; /*关闭弹窗*/
                this.$message("确认成功");
                this.query(); /*查询渲染界面*/
              } else {
                this.$message.info("失败：" + resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        } else {
          console.log("验证没通过");
          return false;
        }
      });
    },
    // 外采订单确认：未排单 -> 已下单未发货
    outOrderConfirm(row) {
      this.$msgbox
        .confirm("确认外采[未排单->已下单未发货]吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.get("/api/order/out-confirm?id=" + row.id).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("确认成功！");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              this.$message.error("操作失败：" + err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },

    // 删除订单
    deleteOrder(row) {
      this.$msgbox
        .confirm("此操作将删除订单信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.delete("/api/order/removeById?id=" + row.id).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
    // 删除订单明细
    deleteOrderDetail(row) {
      this.$msgbox
        .confirm("此操作将删除订单明细信息, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          this.axios.delete("/api/order-detail/removeById?id=" + row.detailId).then(
            (resp) => {
              if (resp.data.code == 200) {
                this.$message("删除成功");
                this.query();
              } else {
                this.$message(resp.data.msg);
              }
            },
            (err) => {
              console.log("err", err);
            }
          );
        })
        .catch(() => {
          this.$message.error("已取消");
        });
    },
    clickFnskuDown(row) {
      this.downDialog = true;
      this.downorderId = row.id;
      this.downDetailfnskuPdfPathObj = row.fnskuPdfPathObj;
    },

    downFileFnsku(businessType) {
      this.axios.get("/api/order/validOrderIsDownload?id=" + this.downorderId + "&businessType=" + businessType).then(
        (resp) => {
          if (resp.data.code == 200) {
            // let baseurl = this.axios.defaults.baseURL;
            // var value = window.open(`${baseurl}/api/order/orderZipDownload?id=` + this.downorderId + ` &businessType=` + businessType, "_blank");
            // console.log(value);
            let path="/api/order/orderZipDownload?id=" + this.downorderId + "&businessType=" + businessType;
            this.axios({
              url: path,
              method: 'get',
              responseType: 'blob',
            }).then(res => {
                console.log('res', res);
                this.downloadCallback(res, this.getFileName(res));
              }
            ).catch(err => {
              console.log(err.message);
            });
            /*加个下载成功的进度条*/
            setTimeout(() => {
              this.downDialog = false;
              this.downDetailfnskuPdfPath = [];
            }, 500);
            this.$message({
              message: "下载成功",
              type: "success",
              center: true,
            });
          } else {
            this.$message.info("暂未上传文件");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },
    downloadAllfile(row) {
      this.$msgbox
        .confirm("此操作将下载压缩文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          //let baseurl = this.axios.defaults.baseURL;
          //window.open(`${baseurl}/api/order/orderZipDownload?id=` + row.id, "_blank");
          let path = "/api/order/orderZipDownload?id=" + row.id;
          this.axios({
            url: path,
            method: 'get',
            responseType: 'blob',
          }).then(res => {
              console.log('res', res);
              this.downloadCallback(res, this.getFileName(res));
            }
          ).catch(err => {
            console.log(err.message);
          });
          /*加个下载成功的进度条*/
          setTimeout(() => {
            this.loading = false;
            this.downDialog = false;
          }, 500);
          this.$message({
            message: "下载成功",
            type: "success",
            center: true,
          });
        })
        .catch(() => {
          this.$message.error("已取消下载");
        });
    },
    downLoadOrderFile() {
      let path = `/api/order/export?1=1`;
      if (this.formInline.orderDate) {
        path += "&orderDate=" + this.formInline.orderDate;
      }
      if (this.formInline.orderStatus) {
        path += "&orderStatus=" + this.formInline.orderStatus;
      } 
      if (this.formInline.brand) {
        path += "&brand=" + this.formInline.brand;
      }
      if (this.formInline.site) {
        path += "&site=" + this.formInline.site;
      }
      if (this.formInline.type) {
        path += "&type=" + this.formInline.type;
      } 
      if (this.formInline.orderNo) {
        path += "&orderNo=" + this.formInline.orderNo;
      }
      if (this.formInline.sku) {
        path += "&sku=" + this.formInline.sku;
      }
      if (this.formInline.fnsku) {
        path += "&fnsku=" + this.formInline.fnsku;
      }
      if (this.formInline.priority) {
        path += "&priority=" + this.formInline.priority;
      }
      this.axios({
        url: path,
        method: 'get',
        responseType: 'blob',
      }).then(res => {
          console.log('res', res);
          this.downloadCallback(res, '订单列表.xlsx');
        }
      ).catch(err => {
        console.log(err.message);
      });
      //window.open(path, "_blank");
      /*加个下载成功的进度条*/
      // setTimeout(() => {
      //   this.$message({
      //     message: "下载成功",
      //     type: "success",
      //     center: true,
      //   });
      // }, 2000);
    },
    downloadCallback(res, fileName) {
      var blob = new Blob([res.data], 
        {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8'});
        var download = document.createElement('a');
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        download.style.display = 'none';
        download.href = href;
        download.download =fileName ; //下载后文件名
        document.body.appendChild(download);
        download.click(); //点击下载
        document.body.removeChild(download); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
    },
    getFileName(res) {
      let fileName=decodeURI((res.headers['content-disposition'].split('='))[1]);
      return fileName;
    },
    uploadOrderfile(row) {
      this.fileList = [];
      this.uploadDialog = true;
      this.upload.id = row.id;
    },
    uploadBtnChange(type) {
      this.upload.businessType = type;
      //log(this.upload.businessType, 'this.businessType')
      if (this.upload.businessType == 0) {
        this.formFilename = "PDF文件：";
      } else if (this.upload.businessType == 1) {
        this.formFilename = "相关文件：";
      }
      this.fileList = [];
      this.uploadDialog = true;
    },

    submitUpload(file, fileList) {
      this.file = file;
      let s = file.name;
      this.upload.ext = s.substr(s.lastIndexOf(".") > 0 ? s.lastIndexOf(".") + 1 : 0);
      this.fileList = fileList.slice(-1);
      this.upload.file = file;
      this.generatorFileMd5(file, this.setMD5);
    },
    importOrderSubmitUpload(file, fileList) {
      this.file = file;
      let s = file.name;
      this.upload.ext = s.substr(s.lastIndexOf(".") > 0 ? s.lastIndexOf(".") + 1 : 0);
      this.fileList = fileList.slice(-1);
      this.upload.file = file;
      this.generatorFileMd5(file, this.setMD5New('importOrder'));
    },
    generatorFileMd5(file, callback) {
      //声明必要的变量
      var fileReader = new FileReader(),
        //文件每块分割2M，计算分割详情
        chunkSize = 2097152,
        chunks = Math.ceil(file.size / chunkSize),
        currentChunk = 0,
        //创建md5对象（基于SparkMD5）
        spark = new SparkMD5();
      let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
      //每块文件读取完毕之后的处理
      fileReader.onload = function(e) {
        let called = false;
        //每块交由sparkMD5进行计算
        spark.appendBinary(e.target.result);
        currentChunk++;

        //如果文件处理完成计算MD5，如果还有分片继续处理
        if (currentChunk < chunks) {
          loadNext();
        } else {
          if (!called) {
            called = true;
            callback(spark.end());
          }
        }
      };

      //处理单片文件的上传
      function loadNext() {
        var start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsBinaryString(blobSlice.call(file.raw, start, end));
      }

      loadNext();
    },
    setMD5(md5) {
      const index = this.upload.file.name.lastIndexOf(".");
      var flieArr = this.upload.file.name.substring(index, this.upload.file.name.length);
      this.upload.md5 = md5;
      let formData = new FormData();
      formData.append("file", this.upload.file.raw);
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
          this.progress = completeProgress;
        },
      };
      this.$http.post("/api/order/file-upload?id=" + this.upload.id, formData, config).then(
        (resp) => {
          this.upload = {};
          if (resp.data.code == 200) {
            this.$message("上传成功");
            setTimeout(() => {
              this.uploadDialog = false;
              this.dialogVisible = false;
            }, 3000);

            this.query();
          } else {
            this.$message(resp.data.msg);
            this.$message("上传失败");
          }
        },
        (err) => {
          console.log("err", err);
        }
      );
    },

    setMD5New(path, fileName) {
      let formData = new FormData();
      // 向 formData 对象中添加文件
      // formData.append("md5", this.upload.md5);
      formData.append("file", this.file.raw);
      console.log(formData.get("file"), "formDataformData");
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
        //添加上传进度监听事件
        onUploadProgress: (e) => {
          var completeProgress = (((e.loaded / e.total) * 100) | 0) + "%";
          this.progress = completeProgress;
        },
      };
      this.$http.post("/api/order/" + path, formData, config).then(
        (resp) => {
          this.upload = {};
          console.log(resp, '导入');
          if (resp.data.code == 200) {
            // 导入正确
            let pathNew = resp.data.data.failFilePath;
            // failFilePath有的话是导入条目失败了 有失败原因
            if (pathNew) {
              pathNew = "/api/sku-info/templateDownload?path=" + pathNew;
              this.axios({
                url: pathNew,
                method: 'get',
                responseType: 'blob',
              }).then(res => {
                  this.downloadCallback(res, this.getFileName(res));
                  if (path == 'importOrder') {
                    this.importOrderInfoShow = false;
                    this.fileList = [];
                    this.query();
                  }
                }
              ).catch(err => {
                console.log(err.message);
              });
            } else {
              if (path == 'importOrder') {
                this.importOrderInfoShow = false;
              }
              this.fileList = [];
              this.query();
            }
            // 提示导入信息
            setTimeout(() => {
              this.$message(resp.data.data.result);
            }, 3000);
          } else {
            if (resp.data.code == 50000) {
              if (path == 'importOrder') {
                this.importOrderInfoShow = false;
              }
              this.fileList = [];
              this.query();
              return this.$message(resp.data.msg);
            }
            let path = resp.data.failFilePath;
            if (path) {
              path = "/order/template/" + fileName;
              let pathT="/api/sku-info/templateDownload?path=" + path;
              this.axios({
                url: pathT,
                method: 'get',
                responseType: 'blob',
              }).then(res => {
                  console.log('res', res);
                  this.downloadCallback(res, this.getFileName(res));
                }
              ).catch(err => {
                console.log(err.message);
              });
              this.fileList = [];
              this.query();
            }
          }
        },
        (err) => {
          this.fileList = [];
          console.log("err", err);
        }
      );
    },
  },
};
</script>

<!--表现 css-->
<style>
.el-table .red-row {
  background: red;
  color: white;
}
.el-table .purple-row {
  background-color: #96208c !important;
  color: white;
}
.el-table .orange-row {
  background: #f7aa4b;
  color: white;
}
</style>
<style lang="less" scoped>
.page {
  width: 100%;
  height: calc(100% - 60px);

  .title {
    height: 50px !important;
    color: white;
    font-size: 16px;
    background: #2cc7c7;
    line-height: 50px;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }
  &-content {
    background-color: white;
    height: calc(100% - 106px);
    overflow: auto;
  }
  .login-out {
    margin-top: 20px;
  }

  .el-input--small {
    font-size: 10px;
    width: 140px;
  }

  .el-form--inline .el-form-item {
    display: inline-block;
    margin-top: 15px;
    vertical-align: top;
    margin-right: 10px;
  }

  .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 18px;
    color: #666e92;
    line-height: 40px;
    padding: 0 20px 0 0;
    box-sizing: border-box;
  }
  /*分页插件*/
  .el-pagination {
    background-color: #fff;
    padding: 15px;
    text-align: center;
    z-index: 55555;
  }
}

.center-dialog {
  top: 15%;
}

.el-pagination.is-background /deep/ .el-pager li:not(.disabled).active {
  background-color: #2cc7c7;
}

::v-deep .success-row {
  background-color: #aedd94 !important;
}
</style>
